export enum TaskType {
    NONE = 0,
    ZONING_CODE_INDEXING = 1,
    ZC_VERSION_CALCULATION = 2,
    CALCULATE_FOLIOS = 3,
    GET_3D_TILES_DATA = 4,
    GET_AUTOMATION_DATA_JOB = 5,
    COLLECT_AUTOMATION_DATA = 6,
    FILL_ZC_APPLICABLE_TYPOLOGIES = 7,
    CALCULATE_ALL_TYPOLOGIES = 8,
    FILL_FOLIOS_APPLICABLE_TYPOLOGIES = 9,
    CALCULATE_RESULTS_FOR_TYPOLOGIES = 10,
    SAVE_RESULT_AND_CREATE_ATTACHMENT = 11,
    COLLECT_TILES_DATA = 12,
    // IMPORT_NEW_PR_IDS = 13,
    // IMPORT_NEW_ZCV_IDS = 14,
    // IMPORT_NEW_STREET_IDS = 15,
    RECALCULATE_BY_STATUS = 16,
    REMOVE_PROPERTY_RECORDS = 17,
    CALCULATE_FOLIOS_MULTI_THREAD = 18,
    CALCULATE_RESULTS_FOR_TYPOLOGIES_MULTI_THREAD = 19,
    RECALCULATE_BY_STATUS_MULTI_THREAD = 20,
    ZONING_CODE_INDEXING_WITH_CURSOR = 21,
    REPLACE_LAND_USE_IDS = 22,
    COLLECT_PRS_ZONING_DATA = 23,
    COLLECT_PRS_OVERLAYS_DATA = 24,
    SYNC_ZONING_CODE_SOLR_DATA = 25,
    REMOVE_ZONING_CODE_SOLR_DATA = 26,
    COLLECT_PRS_MARKET_DATA = 27,
    REMOVE_ZCV_CRS_PROCESS = 28,
    REMOVE_ZCV_CRS_JOB = 29,
    REMOVE_ZONING_CODE_JOB = 30,
    REMOVE_ZC_PRS_PROCESS = 31,
    REMOVE_ZC_EVENTS_PROCESS = 32,
    RECALCULATE_LISTED_BY_STATUS_JOB = 33,
    CREATE_PRS_LIST_BY_STATUS_PROCESS = 34,
    SYNC_ZC_PRS_JOB = 35,
    CREATE_ZC_ORPHAN_PRS_LIST_PROCESS = 36,
    REINDEX_MISSED_ZC_AU_JOB = 37,
    GET_SOLR_GROUP_IDS_WITHOUT_AU_PROCESS = 38,
    GET_MISSED_AU_GROUP_IDS_PROCESS = 39,
    SYNC_PRS_AU_PROCESS = 40,
    FILL_BUILDING_MODEL_GEOMETRIES_JOB = 41,
    CALCULATE_GROUP_IDS_WITH_UPDATED_PLACES_JOB = 42,
    REMOVE_AU_FOR_GROUP_IDS_WITH_UPDATED_PLACES_PROCESS = 43,
    GET_GROUP_IDS_WITH_UPDATE_PLACES_TO_RECALCULATE = 44
}

export function getPrettyTaskType(taskType: number): string {
    return [
        '',
        'Indexing',
        'Calculation',
        'Calculate Property Records',
        'Get 3D Tiles data',
        'Get Automation data',
        'Collect Automation data',
        'Fill Zoning Code Applicable Typologies',
        'Calculate Typologies',
        'Fill folios applicable typologies',
        'Calculate results for each typology',
        'Saving result files',
        'Collect Tiles data',
        'Import Plain Ids for Property Records',
        'Import Plain Ids for Zoning Code Versions',
        'Import Plain Ids for Building Frontages',
        'Recalculate Property Records by calculation status',
        'Remove Property Records and Calculation Results',
        'Calculate Property Records (Multi-thread)',
        'Calculate results for each typology (Multi-thread)',
        'Recalculate Property Records by calculation status (Multi-thread)',
        'Indexing (with cursor)',
        'Replace Gridics Ids',
        'Collect Property Records Zoning data',
        'Collect Property Records Overlays data',
        'Synchronize Zoning Code Solr Data',
        'Remove Zoning Code Solr Data',
        'Collect Property Records Market data',
        'Remove Calculation Results',
        'Remove Zoning Code Version Calculation Results',
        'Remove Zoning Code',
        'Remove Zoning Code Property Records',
        'Remove Zoning Code Events',
        'Recalculate Property Records by calculation status (By list)',
        'Create Property Records Task Items by calculation status',
        'Synchronize Zoning Code Property Records (fix orphans)',
        'Create Zoning Code Orphan Property Records List',
        'Reindex missed Zoning Code Allowed Uses',
        'Get Solr Group Ids without Allowed Uses',
        'Get missed Allowed Uses Group Ids',
        'Sync Property Records Allowed Uses',
        'Fill Building Model Geometries',
        'Calculate Group Ids with Updated Places',
        'Remove Allowed Uses for Group Ids with Updated Places',
        'Get Group Ids with Updated Places to Recalculate'
    ][taskType];
}

export function getTaskDescriptionByTaskType(taskType: number): string {
    return [
        '',
        'Indexing', // 1
        'Calculation', // 2
        "This Job Type processes and calculates list of property records, but doesn't return result file.", // 3
        'This Job Type calculates the list of Property Records and returns two 3D Tiles data result files in JSON format (Feature Collections Array and Combined Features).', // 4
        'This Job Type calculates the list of Property Records and returns file with calculation result in CSV format.', // 5
        'Collect Automation data', // 6
        'This Job Type determines applicable typologies for Property records of selected ZC and saves them to DB. Can be performed only for Property Records that are already calculated.', // 7
        'This Job Type calculates the list of Property Records for each applicable typology.', // 8
        'Fill folios applicable typologies', // 9
        'Calculate results for each typology', // 10
        'Saving result files', // 11
        'Collect Tiles data', // 12
        'Import new Property Record IDs', // 13
        'Import new Zoning Code Version IDs', // 14
        'Import new Streets IDs', // 15
        'This job recalculates Property Records by calculation status', // 16,
        'This job removes Property Records and calculation results', // 17,
        "This Job Type processes and calculates list of property records, but doesn't return result file (Multi-thread).", // 18,
        'Calculate results for each typology (Multi-thread)', // 19,
        'This job recalculates Property Records by calculation status (Multi-thread)', // 20,
        'Indexing (with cursor)', // 21
        'Replaces Land Use Ids for all entities: Zoning Codes, Zoning Code Versions, Property Records etc',
        'Collects existing Zoning data (Gridics Land Use Id) for all Property Records (GroupId) on the instance. NOTE: This Job should run without any stops, or it will lose portion of cached data.',
        'Collects existing Overlays data (Gridics Id) for all Property Records (GroupId) on the instance. NOTE: This Job should run without any stops, or it will lose portion of cached data.',
        'Collects Calculation Result data for Zoning Code property records and sends data to Sorl',
        'Collects Remove Property Record Solr data commands and sends them to Solr',
        'Collects existing Market State and Market Name for all Property Records (GroupId) on the instance. NOTE: This Job should run without any stops, or it will lose portion of cached data.',
        'Removes All Calculation Results for specified Zoning Code Version',
        'Removes All Calculation Results for specified Zoning Code Version',
        'Removes Zoning Code, related Property Records, Zoning Code Versions, Calculation Results and Solr data',
        'Remove Zoning Code Property Records by Place Gridics Id',
        'Remove Zoning Code Events by Zoning Code Id',
        'Recalculates Property Records by Calculation Status (By list)', // 33
        'Creates Property Records Task Items by calculation status', // 34
        'Synchronizes Zoning Code Property Records (fix orphans). The Job does not delete Property Records and Calculation Results if they belong to other registered Zoning Codes. That is why some discrepancies may remain until all Zoning Codes are synchronized.', // 35
        'Creates Zoning Code Orphan Property Records List', // 36
        'Reindex missed Zoning Code Allowed Uses', // 37
        'Get Solr Group Ids without Allowed Uses', // 38
        'Get missed Allowed Uses Group Ids', // 39
        'Sync Property Records Allowed Uses', // 40
        'Fill Building Model Geometries. Iterated through all Buildings without BuildingModelGeometries relations on the State Instance ', // 41
        'Calculate Group Ids with Updated Places. Finds GroupIds where Place data was updated and triggers recalculation for Allowed Uses', // 42
        'Removes Allowed Uses for Group Ids with Updated Places', // 43
        'Get Group Ids with Updated Places to Recalculate' // 44
    ][taskType];
}
